import PROMISED_PAYMENT_API from 'api/promised-payment/v1'
import WALLETS_API from 'api/wallets/v1'
import { call, put, select, takeLatest } from 'redux-saga/effects'
import prepareFilterParams from 'utils/prepareFilterParams'
import { notificationShow } from 'modules/Notifications/actions'
import { cancellableCall } from 'store/saga-utils/cancellableCall.saga'
import {
  CHANGE_ACTIVE_WALLET_ID,
  FETCH_EXPIRED_PAYMENTS,
  FETCH_WALLET_PROMISED_PAYMENTS,
  FETCH_WALLET_TRANSACTIONS,
  FETCH_WALLETS,
  SET_ACTIVE_WALLET_ID,
  SET_PROMISED_PAYMENTS,
  SET_WALLET_TRANSACTIONS,
  SET_WALLETS,
} from 'modules/Finance/Wallets/types'

export function* fetchWallets() {
  try {
    yield put({ type: SET_WALLETS, payload: { loading: true } })
    const { response, error } = yield call(WALLETS_API.fetchWallets)

    if (error) {
      throw error
    }

    yield put({
      type: SET_WALLETS,
      payload: { ...response, loaded: true },
    })
  } catch (error) {
    yield put({
      type: SET_WALLETS,
      payload: { loadFailed: true },
    })
    yield put(
      notificationShow({
        type: 'error',
        message: 'common::notifications.data_fetch_failed',
      }),
    )
    console.logXHR(error)
  } finally {
    yield put({ type: SET_WALLETS, payload: { loading: false } })
  }
}

export function* getWalletTransactions(action) {
  const {
    activeWalletID: id,
    filters,
    transactions: { data: transactions = [], limit },
  } = yield select((state) => state['finance/wallets'])

  const params = {
    ...prepareFilterParams(filters),
    limit,
    offset: action?.payload?.offset ?? 0,
  }

  try {
    yield put({
      type: SET_WALLET_TRANSACTIONS,
      payload: {
        loading: true,
      },
    })

    const { canceled, response, error } = yield cancellableCall(
      WALLETS_API.fetchTransactions,
      { id, params },
      arguments,
    )

    if (error) {
      throw error
    }

    if (canceled) return

    const { data = [], pagination, summary = {} } = response

    yield put({
      type: SET_WALLET_TRANSACTIONS,
      payload: {
        data: [...transactions, ...data],
        pagination,
        categories: summary,
        loaded: true,
        loading: false,
      },
    })
  } catch (error) {
    yield put({
      type: SET_WALLET_TRANSACTIONS,
      payload: { loadFailed: true, loading: false },
    })
    yield put(
      notificationShow({
        type: 'error',
        message: 'common::notifications.data_fetch_failed',
      }),
    )
    console.logXHR(error)
  }
}

export function* fetchPromisedPayments({ payload = {} }) {
  try {
    yield put({
      type: SET_PROMISED_PAYMENTS,
      payload: {
        loading: true,
      },
    })

    const { response, error } = yield call(PROMISED_PAYMENT_API.fetchAll, payload)

    if (error) {
      throw error
    }

    yield put({
      type: SET_PROMISED_PAYMENTS,
      payload: {
        data: response.data,
        loaded: true,
      },
    })
  } catch (error) {
    yield put({
      type: SET_PROMISED_PAYMENTS,
      payload: {
        loadFailed: true,
      },
    })
    yield put(
      notificationShow({
        type: 'error',
        message: 'common::notifications.data_fetch_failed',
      }),
    )
    console.logXHR(error)
  } finally {
    yield put({
      type: SET_PROMISED_PAYMENTS,
      payload: {
        loading: false,
      },
    })
  }
}

export function* changeActiveWalletID({ payload }) {
  yield put({
    type: SET_ACTIVE_WALLET_ID,
    payload,
  })
}

export function* fetchWalletPromisedPayments({ payload }) {
  const {
    filters,
    transactions: { limit, data: transactions = [], pagination },
    activeWalletID,
  } = yield select((state) => state['finance/wallets'])

  const params = {
    ...prepareFilterParams(filters),
    limit,
    wallets: [activeWalletID],
    ...payload,
  }

  try {
    yield put({
      type: SET_WALLET_TRANSACTIONS,
      payload: {
        loading: true,
      },
    })

    const { response, error } = yield cancellableCall(
      PROMISED_PAYMENT_API.fetchAll,
      {
        params,
      },
      arguments,
    )

    if (error) {
      throw error
    }

    const { data = [] } = response

    yield put({
      type: SET_WALLET_TRANSACTIONS,
      payload: {
        data: [...transactions, ...data],
        pagination: { ...pagination, ...response.pagination },
        loaded: true,
      },
    })
  } catch (error) {
    yield put({
      type: SET_WALLET_TRANSACTIONS,
      payload: { loadFailed: true },
    })
    yield put(
      notificationShow({
        type: 'error',
        message: 'common::notifications.data_fetch_failed',
      }),
    )
    console.logXHR(error)
  } finally {
    yield put({
      type: SET_WALLET_TRANSACTIONS,
      payload: {
        loading: false,
      },
    })
  }
}

export default function* Sagas() {
  yield takeLatest(FETCH_WALLETS, fetchWallets)

  yield takeLatest(CHANGE_ACTIVE_WALLET_ID, changeActiveWalletID)

  yield takeLatest(FETCH_WALLET_TRANSACTIONS, getWalletTransactions)

  yield takeLatest(FETCH_EXPIRED_PAYMENTS, fetchPromisedPayments)

  yield takeLatest(FETCH_WALLET_PROMISED_PAYMENTS, fetchWalletPromisedPayments)
}
